import { render, staticRenderFns } from "./pago-pse.vue?vue&type=template&id=4cd22f6b&scoped=true&"
import script from "./pago-pse.vue?vue&type=script&lang=js&"
export * from "./pago-pse.vue?vue&type=script&lang=js&"
import style0 from "./pago-pse.vue?vue&type=style&index=0&id=4cd22f6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd22f6b",
  null
  
)

export default component.exports